function createLegacyProductPath(productName) {
    return `/shop/products/${productName
        .toLowerCase()
        .trim()
        .replaceAll(" ", "-")
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .replace(/\u0142/g, "l")}`;
}

function createProductPath(productName) {
    const slug = createLegacyProductPath(productName)
        .slice("/shop/products/".length)
        .replace(/[^a-z0-9-]+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-|-$/g, "");

    return `/shop/products/${slug || "produkt"}`;
}

module.exports = {createProductPath, createLegacyProductPath};
